import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicTable, TableFilter, EmptyState, BaasicButton, BaasicModal, BaasicConfirmModal, GlobalSignalRListener } from "core/components";
import { isSome } from "core/utils";
import { ApplicationListLayout, Content } from "core/layouts";
import { toDate } from 'core/utils';
import { BackOrderEditModal } from "application/pick-ticket/components";
import { PickTicketInfoModal, PickTicketDetailNewFlowItemDetailsModal, PickTicketRefreshConfirmationModal } from "application/pick-ticket-new-flow/components";
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { FacilityOrderNewFlowNonScheduledTubesModal } from "application/facility-order-new-flow-order-summary/components";
import { PrimaryRecipientErrorModal } from "application/facility-order-new-flow-order-summary/components";

const PickTicketNewFlowDetailListTemplate = function ({ pickTicketNewFlowDetailListViewStore, t }) {
    const {
        tableStore,
        routes,
        queryUtility,
        authorization,
        pickTicketHeader,
        deliveryDate,
        backOrderEditModal,
        downloadReport,
        openFacilityOrderNewFlowNonScheduledTubesModal,
        refreshNewFlow,
        openPickTicketInfoModal,
        pickTicketInfoModal,
        pickTicketDetailNewFlowItemDetailsModal,
        sendOrderLoading,
        sendingAgoraPo,
        isOrderSent,
        pickTicketRefreshConfirmationModal,
        pickTicketCreateInProgresConfirmationModal,
        rootStore,
        signalRAction,
        sendAgoraPo,
        isImportDisabled,
        facilityOrderStatus,
        isImportButtonVisible,
        importConfirmModal,
        showImportConfirmModal,
        facilityOrderNewFlowNonScheduledTubesModal,
        disabledSendOrder,
        primaryRecipientErrorModal
    } = pickTicketNewFlowDetailListViewStore;

    const facilityName = pickTicketHeader && pickTicketHeader.facilityOrders[0].facility.name;
    const facilityAddress = pickTicketHeader && pickTicketHeader.facilityOrders[0].facility.address;
    const dateOfService = pickTicketHeader && toDate(pickTicketHeader.facilityOrders[0].dateOfService);
    const dateOfDelivery = deliveryDate && toDate(deliveryDate);
    const dateCreated = pickTicketHeader && toDate(pickTicketHeader.facilityOrders[0].dateCreated, true);
    const pickTicketNo = pickTicketHeader && `${pickTicketHeader.pickTicketNo}`;
    return (
        <React.Fragment>
            {pickTicketHeader && pickTicketHeader.facilityOrders[0] && <GlobalSignalRListener groupId={pickTicketHeader && pickTicketHeader.facilityOrders[0].id} rootStore={rootStore} action={signalRAction} />}
            <div className="header-custom">
                <div className="u-flex u-flex--space-between">

                    <div>
                        <div>
                            <h2>{pickTicketNo}</h2>
                            <div>
                                <span className="u-mar--right--tny">{facilityName}</span>
                            </div>
                            <div>
                                <span className="u-mar--right--tny">{facilityAddress}</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <span>Date Created: <strong>{dateCreated}</strong></span>
                        </div>
                        <div>
                            <span>Status: <strong>{pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.name}</strong></span>
                        </div>
                    </div>
                    <div>
                        <div className="u-mar--left--lrg">
                            <div>
                                <span>Date of Service: <strong>{dateOfService}</strong></span>
                            </div>
                            <div>
                                <span>Delivery Date: <strong>{dateOfDelivery}</strong></span>
                            </div>
                        </div>
                    </div>
                    <div className="u-flex u-flex--space-between u-flex--row-reverse">
                        <div className="u-push">
                            <DropDownButton
                                fillMode={"solid"}
                                themeColor={"primary"}
                                text="Download"
                                onItemClick={(e) => downloadReport(e.item.text)}
                                buttonClass="btn btn--base btn--ghost"
                                popupSettings={{
                                    animate: false,
                                    anchorAlign: { horizontal: "right", vertical: "bottom" },
                                    popupAlign: { horizontal: "right", vertical: "top" },
                                    popupClass: 'is-clean'
                                }}
                            >
                                {pickTicketHeader && pickTicketHeader.facilityOrders[0].facility.sendAgoraPo &&
                                    <DropDownButtonItem text="Agora PO" />
                                }
                                <DropDownButtonItem text="FO Report" />
                                <DropDownButtonItem text="Pick Ticket PDF" />
                                <DropDownButtonItem text="Pick Ticket XLSX" />
                            </DropDownButton>
                        </div>
                        {isImportButtonVisible && <BaasicButton className="btn btn--base btn--primary u-mar--right--tny u-push"
                            rotate icon={
                                isImportDisabled
                                    ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                    : 'u-display--none'
                            }
                            label={t('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.IMPORT')}
                            onClick={async () => await showImportConfirmModal()}
                            disabled={!(pickTicketHeader && pickTicketHeader.facilityOrders[0].sendOrder) || (facilityOrderStatus && facilityOrderStatus.completedOn)}
                        />}
                        {pickTicketHeader && pickTicketHeader.facilityOrders[0].facility.sendAgoraPo &&
                            <BaasicButton
                                rotate icon={
                                    sendingAgoraPo
                                        ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                        : 'u-display--none'
                                } disabled={sendingAgoraPo}
                                className="btn btn--base btn--primary u-mar--right--tny u-push" label={'Send Agora PO'} onClick={() => sendAgoraPo()}></BaasicButton>
                        }
                        <BaasicButton className="btn btn--base btn--primary u-mar--right--tny u-push" label={'Send Order'} onClick={() => openFacilityOrderNewFlowNonScheduledTubesModal()}
                            rotate icon={
                                sendOrderLoading
                                    ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                    : 'u-display--none'
                            } disabled={sendOrderLoading || isOrderSent}></BaasicButton>
                        <BaasicButton className="btn btn--base btn--primary u-mar--right--tny u-push" disabled={disabledSendOrder} label={'Refresh'} onClick={() => refreshNewFlow()}></BaasicButton>
                        <BaasicButton className="btn btn--base btn--primary u-mar--right--tny u-push" label={'Info'} onClick={() => openPickTicketInfoModal()}></BaasicButton>
                    </div>
                </div>
            </div>
            <ApplicationListLayout
                store={pickTicketNewFlowDetailListViewStore}
                authorization={authorization}
            >
                <Content emptyRenderer={renderEmpty(routes)}>
                    <div className="u-mar--bottom--sml">
                        <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        </TableFilter>
                    </div>
                    <div className="card--table">
                        <BaasicTable
                            authorization={authorization}
                            tableStore={tableStore}
                            actionsComponent={renderActions}
                        />
                    </div>
                    <BaasicModal modalParams={backOrderEditModal} className="modal__content modal--sml">
                        <BackOrderEditModal />
                    </BaasicModal>
                </Content>
            </ApplicationListLayout>
            <BaasicModal modalParams={pickTicketInfoModal} className="modal__content modal--xlrg">
                <PickTicketInfoModal />
            </BaasicModal>
            <BaasicModal modalParams={pickTicketRefreshConfirmationModal} className="modal__content modal--lrg">
                <PickTicketRefreshConfirmationModal />
            </BaasicModal>
            <BaasicModal modalParams={pickTicketDetailNewFlowItemDetailsModal} className="modal__content modal--xlrg">
                <PickTicketDetailNewFlowItemDetailsModal />
            </BaasicModal>
            <BaasicConfirmModal modalParams={pickTicketCreateInProgresConfirmationModal} />
            <BaasicConfirmModal modalParams={importConfirmModal} />
            <BaasicModal modalParams={facilityOrderNewFlowNonScheduledTubesModal} className="modal__content modal--xlrg">
                <FacilityOrderNewFlowNonScheduledTubesModal />
            </BaasicModal>
            <BaasicModal modalParams={primaryRecipientErrorModal} className="modal__content modal--sml">
                <PrimaryRecipientErrorModal />
            </BaasicModal>
        </React.Fragment>
    );
};

function renderEmpty() {
    return (
        <EmptyState
            title="PICK_TICKET_DETAIL.LIST.EMPTY_STATE.TITLE"
        />
    );
}

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;
    const { onEdit } = actions;
    if (!isSome(onEdit)) return null;
    const { onPreview } = actions;
    if (!isSome(onPreview)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--preview u-icon--sml"
                        label="PICK_TICKET_DETAIL.LIST.BUTTON.ITEM_DETAILS"
                        onlyIcon={true}
                        onClick={() => onPreview(item)}
                    ></BaasicButton>
                ) : null}
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--edit u-icon--sml"
                        label="PICK_TICKET_DETAIL.LIST.BUTTON.UPDATE_BACK_ORDER"
                        onlyIcon={true}
                        onClick={() => onEdit(item)}
                    ></BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
}

PickTicketNewFlowDetailListTemplate.propTypes = {
    pickTicketNewFlowDetailListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(PickTicketNewFlowDetailListTemplate);